import { render, staticRenderFns } from "./RejectComment.vue?vue&type=template&id=31a13932&scoped=true&"
import script from "./RejectComment.vue?vue&type=script&lang=js&"
export * from "./RejectComment.vue?vue&type=script&lang=js&"
import style0 from "./RejectComment.vue?vue&type=style&index=0&id=31a13932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a13932",
  null
  
)

export default component.exports